export default __webpack_public_path__ + "static/media/minus.fab82ee9.svg";